import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import Information from './components/Information';
import ContentsInformation from './components/ContentsInformation';
import KitsInformation from './components/KitsInformation';
import ShowContainer from '../../shared/components/show/ShowContainer';

const BatchsShow = () => (
  <Container>
    <ShowContainer>
      {
        (resourceitem) => {
          if (Object.keys(resourceitem).length === 0) return null;
          return (
            <Container>
              <Information resourceitem={resourceitem} />
              <hr />
              <ContentsInformation resourceitem={resourceitem} />
              <hr />
              <KitsInformation resourceitem={resourceitem} />
            </Container>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(BatchsShow));
